import { render, staticRenderFns } from "./genbyidea.vue?vue&type=template&id=09f70371&scoped=true"
import script from "./genbyidea.vue?vue&type=script&lang=js"
export * from "./genbyidea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f70371",
  null
  
)

export default component.exports